const base = '/train',
    basePath = `pages${base}`;
export default [
  {
      path:`/train/index`,
      name:'trainIndex',
      component:r => require.ensure([], () => r(require(`@/${basePath}/train/index`)), 'trainIndex'),
      meta:{
          tit:'培训管理'
      }
  },
  {
    path:`/train/edit`,
    name:'trainEdit',
    component:r => require.ensure([], () => r(require(`@/${basePath}/train/edit`)), 'trainEdit'),
    meta:{
        tit:'培训管理编辑'
    }
  },
  {
    path:`/subject/index`,
    name:'subjectIndex',
    component:r => require.ensure([], () => r(require(`@/${basePath}/subject/index`)), 'subjectIndex'),
    meta:{
        tit:'培训科目管理'
    }
  },
  {
    path:`/subject/edit`,
    name:'subjectEdit',
    component:r => require.ensure([], () => r(require(`@/${basePath}/subject/edit`)), 'subjectEdit'),
    meta:{
        tit:'培训科目编辑'
    }
  },
  {
    path:`/resource/index`,
    name:'resourceIndex',
    component:r => require.ensure([], () => r(require(`@/${basePath}/resource/index`)), 'resourceIndex'),
    meta:{
        tit:'培训资料'
    }
  },
  {
    path:`/resource/detail`,
    name:'resourceDetail',
    component:r => require.ensure([], () => r(require(`@/${basePath}/resource/detail`)), 'resourceDetail'),
    meta:{
        tit:'培训资料详情'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/router/train.js